import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AggregatorAccountBox from 'components/aggregator/aggregatorBoxes/aggregatorAccountBox/aggregatorAccountBox';
import { AggregatorGenericView } from './aggregatorGenericView/aggregatorGenericView';

import { ACCOUNTS } from 'constants/aggregator/products';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

class AggregatorAccountsViewClass extends React.PureComponent {
  getProductComponent(product, isTinkAggregator, onExpand) {
    const id = product.get('id');
    const iban = product.get('iban');
    const alias = product.get('alias');
    const balance = product.get('balance');
    const lastUpdate = product.get('lastUpdate');
    const details = product.get('details');

    return (
      product && (
        <AggregatorAccountBox
          key={id}
          account={iban}
          id={id}
          alias={alias}
          balance={balance}
          lastUpdate={lastUpdate}
          details={details}
          onExpand={onExpand}
          isTinkAggregator={isTinkAggregator}
        />
      )
    );
  }

  render() {
    const { immFlagBasedFeatures } = this.props;

    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return (
      <AggregatorGenericView
        hasDetails={true}
        productType={ACCOUNTS}
        getProductComponent={this.getProductComponent}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }
}

AggregatorAccountsViewClass.propTypes = {
  immFlagBasedFeatures: PropTypes.object,
};

AggregatorAccountsViewClass.defaultProps = {
  immFlagBasedFeatures: {},
};

const AggregatorAccountsView = connect(state => {
  return {
    immFlagBasedFeatures: state.flagBasedFeatures,
  };
})(AggregatorAccountsViewClass);

export { AggregatorAccountsView };
